import api from './api';

/**
 * Research Advisor Service
 * Handles requests related to research and advisor collaborations
 */
export const researchAdvisingService = {
  // ==================== Service Requests ====================

  /**
   * Create a new service request
   * @param {Object} requestData - ResearchAdvisingRequestDTO
   */
  async createRequest(requestData) {
    return api.post('/research-advising-requests', requestData);
  },

  /**
   * Get all service requests for a user
   * @param {string} userId - The ID of the user
   */
  async getRequests(userId) {
    return api.get(`/research-advising-requests/user/${userId}`);
  },

  /**
   * Get a specific service request by ID
   */
  async getRequestById(id) {
    return api.get(`/research-advising-requests/${id}`);
  },

  /**
   * Update the status of a service request
   */
  async updateRequestStatus(id, status) {
    return api.patch(`/research-advising-requests/${id}/status/${status}`);
  },

  /**
   * Add documents to a service request
   */
  async addDocuments(id, documents) {
    return api.post(`/research-advising-requests/${id}/documents`, documents);
  },

  /**
   * Update research content/recommendation for a request
   */
  async updateResearchContent(id, content) {
    return api.patch(`/research-advising-requests/${id}/research-content`, { content });
  },

  // ==================== Collaboration ====================

  /**
   * Get all financial outlook reviews
   */
  async getOutlookReviews(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/research-advisor/outlook-reviews?${queryString}`);
  },

  /**
   * Get outlook review by ID
   */
  async getOutlookReview(id) {
    return api.get(`/research-advisor/outlook-reviews/${id}`);
  },

  /**
   * Create outlook review
   */
  async createOutlookReview(reviewData) {
    return api.post('/research-advisor/outlook-reviews', reviewData);
  },

  /**
   * Update outlook review
   */
  async updateOutlookReview(id, reviewData) {
    return api.put(`/research-advisor/outlook-reviews/${id}`, reviewData);
  },
};

export default researchAdvisingService;
